import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Box, Typography, CircularProgress } from "@mui/material";
import { logoutUser } from "../../redux/actions/action";
import { persistor } from "../../redux/store/store";

/**
 * /authentication/logout/ — actually performs the logout, then hard-redirects
 * to the sign-in page.
 *
 * The TopNavbar profile menu (components/Layout/TopNavbar/Profile.js and
 * HorizontalNavbar.js) links here with a plain <a href>. Previously this route
 * rendered a static "You are logged out" template that cleared nothing and
 * never redirected, so the session stayed live and the user was stranded on a
 * dead page. This mirrors LeftSidebarMenu.js's own handleLogout: clear redux +
 * persisted state + auth cookies, then reload into /authentication/sign-in/.
 */
const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutUser());

    ["token", "refreshToken", "admin", "permission"].forEach((name) => Cookies.remove(name));

    // Clear the redux-persist "root" blob so a refresh doesn't rehydrate the
    // old auth state, then leave the app entirely (full reload) so every
    // in-memory cache resets.
    Promise.resolve(persistor.purge())
      .catch(() => {})
      .finally(() => {
        window.location.replace("/authentication/sign-in/");
      });
  }, [dispatch]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography sx={{ fontWeight: 500, color: "text.secondary" }}>Signing you out…</Typography>
    </Box>
  );
};

export default Logout;
